import { config } from "@/config";
import { useFlow } from "@frigade/react";
import * as Frigade from "@frigade/react";
import { OnboardingSteps } from "../OnboardingGuide";
import OnboardingFlow from "./OnboardingFlow";

const OnboardingAISuggestionHint = () => {
  const { flow } = useFlow(config.frigade.flows.gettingStarted);
  const currentStep = flow?.getCurrentStep();

  if ((currentStep?.id as OnboardingSteps) === "ai_suggestion") {
    return (
      <OnboardingFlow>
        <Frigade.Tour
          flowId={config.frigade.flows.aiSuggestionHint}
          defaultOpen={true}
          side="right"
          align="start"
        />
      </OnboardingFlow>
    );
  }
};

export default OnboardingAISuggestionHint;
